import React, { useState } from 'react';
import { MainService } from '../../_services';

const ms = new MainService();

function formatDateForApi(dateStr) {
    const [y, m, d] = dateStr.split('-');
    return `${d}-${m}-${y}`;
}

function isWithinOneMonth(debut, fin) {
    const d1 = new Date(debut);
    const d2 = new Date(fin);
    const limit = new Date(d1);
    limit.setMonth(limit.getMonth() + 1);
    return d2 <= limit;
}

function getDurationDays(debut, fin) {
    if (!debut || !fin || fin < debut) return null;
    const diff = new Date(fin) - new Date(debut);
    return Math.round(diff / (1000 * 60 * 60 * 24));
}

function ExportBdCard() {
    const [dateDebut, setDateDebut] = useState('');
    const [dateFin, setDateFin] = useState('');
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [exporting, setExporting] = useState(false);
    const [exportError, setExportError] = useState(null);

    const validate = () => {
        if (!dateDebut || !dateFin) {
            setError('Les deux dates sont obligatoires.');
            return false;
        }
        if (dateFin < dateDebut) {
            setError('La date de fin doit être postérieure à la date de début.');
            return false;
        }
        if (!isWithinOneMonth(dateDebut, dateFin)) {
            setError('La plage de dates ne peut pas dépasser 1 mois.');
            return false;
        }
        setError(null);
        return true;
    };

    const handleExport = () => {
        if (validate()) setShowModal(true);
    };

    const handleConfirmExport = async () => {
        setExporting(true);
        setExportError(null);
        const apiDateDebut = formatDateForApi(dateDebut);
        const apiDateFin = formatDateForApi(dateFin);
        try {
            const res = await ms.exportRcg(apiDateDebut, apiDateFin);
            const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `rcg-import-${apiDateDebut}-${apiDateFin}.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            setShowModal(false);
        } catch {
            setExportError("Erreur lors de l'export. Veuillez réessayer.");
            setShowModal(false);
        } finally {
            setExporting(false);
        }
    };

    const duration = getDurationDays(dateDebut, dateFin);
    const durationLabel = duration !== null
        ? `${duration} jour${duration > 1 ? 's' : ''}`
        : null;
    const durationOverLimit = duration !== null && !isWithinOneMonth(dateDebut, dateFin);

    return (
        <div className="panel-card">
            <div className="export-date-form">
                <div className="date-input-group">
                    <label className="section-label" htmlFor="export-date-debut">
                        Date de début
                    </label>
                    <div className="date-input-wrapper">
                        <i className="fas fa-calendar-alt date-input-icon" />
                        <input
                            id="export-date-debut"
                            type="date"
                            className="date-input"
                            value={dateDebut}
                            onChange={(e) => { setDateDebut(e.target.value); setError(null); }}
                        />
                    </div>
                </div>

                <div className="date-range-sep">
                    <i className="fas fa-arrow-right" />
                </div>

                <div className="date-input-group">
                    <label className="section-label" htmlFor="export-date-fin">
                        Date de fin
                    </label>
                    <div className="date-input-wrapper">
                        <i className="fas fa-calendar-alt date-input-icon" />
                        <input
                            id="export-date-fin"
                            type="date"
                            className="date-input"
                            value={dateFin}
                            onChange={(e) => { setDateFin(e.target.value); setError(null); }}
                        />
                    </div>
                </div>
            </div>

            {durationLabel && !error && (
                <p className={`export-duration-hint${durationOverLimit ? ' export-duration-hint--warning' : ' export-duration-hint--valid'}`}>
                    <i className={`fas fa-${durationOverLimit ? 'exclamation-triangle' : 'clock'}`} />
                    Période sélectionnée : <strong>{durationLabel}</strong>
                    {durationOverLimit && ' — dépasse la limite d\'1 mois'}
                </p>
            )}

            {error && (
                <p className="form-feedback form-feedback--error">
                    <i className="fas fa-exclamation-circle" /> {error}
                </p>
            )}
            {exportError && (
                <p className="form-feedback form-feedback--error">
                    <i className="fas fa-exclamation-circle" /> {exportError}
                </p>
            )}

            <button
                className="btn-full-green"
                onClick={handleExport}
                disabled={exporting}
                style={{ marginTop: 20 }}
            >
                <i className="fas fa-download" /> Exporter
            </button>

            {showModal && (
                <div className="modal-d">
                    <div className="wrapper-modal">
                        <div className="modal-content small-modal b-btns">
                            <div className="header-modal">
                                <i className="fas fa-file-export" /> Confirmer l'export
                            </div>
                            <div className="content-modal">
                                <p>
                                    Exporter les données du{' '}
                                    <strong>{formatDateForApi(dateDebut)}</strong> au{' '}
                                    <strong>{formatDateForApi(dateFin)}</strong> ?
                                </p>
                                <p className="grey">Le fichier sera téléchargé au format CSV.</p>
                            </div>
                            <div className="footer-modal">
                                <button
                                    className="btn btn-grey"
                                    onClick={() => setShowModal(false)}
                                    disabled={exporting}
                                >
                                    Annuler
                                </button>
                                <button
                                    className="btn btn-blue"
                                    onClick={handleConfirmExport}
                                    disabled={exporting}
                                >
                                    {exporting
                                        ? <><i className="fas fa-spinner fa-spin" /> Export…</>
                                        : 'Confirmer'
                                    }
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export { ExportBdCard };
